<div class="main_wraper">
  <header class="clearfix">
    <div class="mid_container">
      <div class="mid_container_inner">
        <div class="logo"> <img src="assets/images/logo-aba.png" class="img-responsive" /></div>
      </div>
    </div>

  <div class="nav2 ">
      <div class="mid_container ">
        <div class="mid_container_inner">
          <div class="logo_text">BankExec®
            <div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</div>

<div class="user_section clearfix">
  <div class="mid_container">
    <div class="mid_container_inner ">
      <div class="user_name"> Username: <b>{{user_email}}</b></div>
    </div>
  </div>
</div>

<section>
  <div class="login_wraper">
    <div class=" mid_container">
      <div class=" mid_container_inner ">
        <div class="login_section">
          <p class="forgot_pasword_new"> Password was successfully updated. <a href="javascript:void(0)" (click)="Sigin($event)">Click here to login</a></p>
          <!-- <span *ngIf='showLinks=="false"'>
          <p *ngIf='enableLink == "Admin"' class="forgot_pasword_new">  <a href="javascript:void(0)" (click)="AdminHome()">View Admin Pages</a></p>
          <p *ngIf='enableLink == "Instructor"' class="forgot_pasword_new">  <a href="javascript:void(0)" (click)="InstructorHome()">View Instructor Pages</a></p>
            <p *ngIf='enableLink == "InstructorAdmin"' class="forgot_pasword_new">  <a href="javascript:void(0)" (click)="InstructorAdminHome()">View Instructor-admin Pages</a></p>
              <p *ngIf='enableLink == "Student"' class="forgot_pasword_new">  <a href="javascript:void(0)" (click)="StudentHome()">View Student Pages</a></p>
            </span> -->
        </div>
      </div>
    </div>

  </div>
</section>
